// extracted by mini-css-extract-plugin
export default {"root":"IU_Gopja5Yc6pJtQU1t3"};